import { useRef } from "react";
import {
  CAMPOS_DO_CEP,
  mesclarEnderecoDoCep,
  type CampoDoCep,
  type EnderecoDoCep,
} from "../../nucleo/cep";

/**
 * Lembra quais campos do endereço a pessoa editou desde que a última consulta de CEP começou.
 *
 * Uso: `marcar(campo)` em cada `onChange` de logradouro/bairro/cidade/UF; `iniciar` no
 * `aoIniciarBusca` do `CampoDeCep`; `mesclar` no `onEndereco`. Sem isto, a resposta tardia da
 * consulta sobrescreve o que foi digitado enquanto ela voava.
 */
export function useEdicaoDoEndereco() {
  const editados = useRef(new Set<CampoDoCep>());
  return {
    marcar(campo: string) {
      if ((CAMPOS_DO_CEP as readonly string[]).includes(campo)) {
        editados.current.add(campo as CampoDoCep);
      }
    },
    iniciar() {
      editados.current.clear();
    },
    /** Devolve o formulário com a resposta aplicada, respeitando o que foi editado. */
    mesclar<T extends Record<CampoDoCep, string>>(atual: T, achado: EnderecoDoCep): T {
      return mesclarEnderecoDoCep(atual, achado, new Set(editados.current));
    },
  };
}
